import React, { useState } from 'react';
import {
  ResponseErrorBody,
  ResponseErrorBodyDataUnconfirmedEmail
} from '../types';
import { Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import usersEmailResend from './../lib/services/usersEmailResend';

export default function(props: { error: ResponseErrorBody }) {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(false);

  async function resend() {
    setIsDisabled(true);
    await usersEmailResend(
      (props.error.data as ResponseErrorBodyDataUnconfirmedEmail).uid
    );
  }

  return (
    <>
      <Typography variant="body1">{t('successMessage')}</Typography>
      <Button
        onClick={resend}
        disabled={isDisabled}
        fullWidth
        variant="contained"
        color="primary"
      >
        {t('emailResend')}
      </Button>
    </>
  );
}
